import React from "react";
import { FaFacebook } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io";
import { NavLink } from "react-router-dom";
import logo from "../images/logo.jpeg";
const Footer = () => {
  return (
    <footer className="footer-dark">
      <div className="footer-content">
        <div className="footer-section about">
          <img className="logo" src={logo}></img>
          <p>📍 Seven Days Cafe - Tadigadapa
            2-151, Tadigadapa - Penamaluru Rd, Tadigadapa, Poranki, Vijayawada, Andhra Pradesh 521134</p>

        </div>

        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
              <NavLink to="/" className="text-decoration-none">
             
              <li><a href="">Home</a></li>
            </NavLink>
          
            <li><a href="#menu">Menu</a></li>
            <NavLink to="/about" className="text-decoration-none">
             
              <li><a href="">About</a></li>
            </NavLink>
               <NavLink to="/contactus" className="text-decoration-none">
               <li><a href="">Contact Us</a></li>
        
        </NavLink>
           
         
          </ul>
        </div>

        <div className="footer-section social">
          <h3>Follow Us</h3>
          <div className="social-icons">

            <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
            <a href="https://www.instagram.com/sevendays_tadigadapa?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FaSquareInstagram /></a>
            <a
              href="https://wa.me/9196666 96905"   // WhatsApp direct link with your number
              aria-label="WhatsApp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoLogoWhatsapp />
            </a>
          </div>
          <div className="contact-info">
            <p>📞 +91 96666 96905</p>
            <p>📧 info@idealfoods.com</p>

          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Ideal Foods. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
